import { fadeIn, fadeOut } from '../../utilities/helpers';
import { updateWishlists, addToWishlist } from '../product/towishlist';
import { quantityControls as quantity } from './quantity';
import { directOrder } from './directorder';
import 'element-closest-polyfill';
import {toCart} from "../product/tocart";

async function postData(url = '', data: any) {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });
    return response;
}

export class Cart {
    cartItemDeleteConfirm() {
        let itemDelete = document.querySelectorAll('.toggle-delete');
        let closeModal = document.querySelectorAll('.toggle-mdl-close');
        const deleteModal = document.getElementById('modal-deleteProduct');
        if (itemDelete) {
            itemDelete = [].slice.call(itemDelete);
            itemDelete.forEach((button: HTMLElement) => {
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    const action = this.getAttribute('data-action');
                    deleteModal.querySelector('form').setAttribute('action', action);
                    fadeIn(document.querySelector('.modal-background'));
                    fadeIn(deleteModal, 'block', 'below');

                    // ToDo: gibt noch Überschneidungen mit altem modal-background
                    document.querySelector('.modal-background').addEventListener('click', function() {
                        fadeOut(deleteModal, 'block', 'below');
                    })
                });
            });
        }
        if (closeModal) {
            closeModal = [].slice.call(closeModal);
            closeModal.forEach((button: HTMLElement) => {
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    let foundMdl = false;
                    let el = this;

                    while(!foundMdl) {
                        el = el.parentElement;
                        foundMdl = el.classList.contains('mdl');
                    }
                    deleteModal.querySelector('form').setAttribute('action', '');
                    fadeOut(document.querySelector('.modal-background'));
                    fadeOut(el, 'block', 'below');
                });
            });
        }
        if (document.querySelector('.modal-background')) {
            document.querySelector('.modal-background').addEventListener('click', function() {
                fadeOut(document.querySelector('.modal-background'));
            })
        }
        this.handleModalFocus();
    }

    wishlist() {
        const toWishlist: NodeListOf<HTMLElement> = document.querySelectorAll('.cart-wishlist');
        let addToWishlistHandlerSet: boolean = false;
        toWishlist.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();

                if (!addToWishlistHandlerSet) {
                    // Click Listener for AddToWishlist Button in Wishlist Modal
                    const addToWishlistBtn = document.querySelector('.add-to-wishlist');
                    addToWishlistBtn && addToWishlistBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        const productId = (btn.closest('.article-entry') as HTMLElement).dataset.orderItemId;
                        addToWishlist('cart', document.querySelector('.modal-article-id').innerHTML, productId);
                    });
                    addToWishlistHandlerSet = true;
                }

                updateWishlists('cart', btn);
                fadeIn(document.querySelector('.modal-background'));
                fadeIn(document.querySelector('#modal-wishlist'));
            })
        });
        this.handleModalFocus();
    }

    cartAccessories() {
        const openAccessories: Array<HTMLElement> = Array.from(document.querySelectorAll('.cart-accessories'));
        openAccessories.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();

                const accessoryProductIds: Array<string> = btn
                    .getAttribute('data-accessory-ids')
                    .slice(0, -1)
                    .split(',');

                const accessoryData = {} as any;
                accessoryData['productIds'] = accessoryProductIds;
                accessoryData['source'] = 'cart-accessory';
                accessoryData['refArticleId'] = btn.getAttribute('data-article-id');

                const accessoryTableTarget: HTMLElement = document.querySelector('#modal-accessory .product-accessories-list');
                if(accessoryTableTarget) {
                    accessoryTableTarget.innerHTML = '';
                }

                postData('/product/reco-tile/rows/box/default/0/0/1', accessoryData)
                    .then((response: any) => response.text())
                    .then((text: any) => {
                        if(accessoryTableTarget) {
                            accessoryTableTarget.innerHTML = text;
                        }

                        this.initAccessoryIncrementer(document.querySelectorAll('.cart-overlay-accessory-table .accessory-incrementer'));
                        new toCart().initCartAccessory();
                        fadeIn(document.querySelector('#modal-accessory'));
                    }).catch((err: any) => {
                    console.log(err);
                });
            })
        });
    }
    //set clickListeners on quantity controls
    initAccessoryIncrementer(incrementerButtons: any) {
        if(typeof incrementerButtons !== 'undefined') {
            incrementerButtons.forEach((button: HTMLElement) => {
                button.addEventListener('click', () => {
                    const input = button.closest('.accessory-form-field-incremeter').querySelector('.basket-quantity') as HTMLInputElement;
                    const currentValue: number = parseInt(input.value);
                    let newVal: number = 1;

                    if (button.textContent === '+') {
                        newVal = currentValue + 1;
                        button.closest('.accessory-form-field-incremeter').querySelector('.incrementer-dec').classList.remove('incrementer-inactive');
                    } else {
                        // Don't allow decrementing below 1
                        if (currentValue > 1) {
                            newVal = currentValue - 1;
                        } else {
                            newVal = 1;
                        }
                        if (newVal <= 1) button.classList.add('incrementer-inactive');
                        if (newVal > 1) button.classList.remove('incrementer-inactive');
                    }

                    input.value = newVal.toString();
                });
            });
        }
    }

    resizeForWindows() {
        const heart :HTMLElement = document.querySelector('.heart-icon');

        if (heart && window.navigator.platform.indexOf("Win") != -1) {
            heart.style.position = 'relative';
            heart.style.bottom = '0.08rem';
        }
    }

    init() {
        //this.resizeForWindows();
        quantity('.checkout');
        this.cartItemDeleteConfirm();
        this.wishlist();
        if(document.querySelector('.cart-accessories')) {
            this.cartAccessories();
        }
        directOrder();
    }

    handleModalFocus(): void {
        // Attach modal focus for delete modal
        this.attachModalFocus(".toggle-delete", "#modal-deleteProduct", "#cancel-delete");

        // Attach modal focus for wishlist modal
        this.attachModalFocus(".cart-wishlist", "#modal-wishlist", "#close-modal");
    }

    attachModalFocus(triggerSelector: string, modalSelector: string, closeButtonSelector: string): void {
        document.addEventListener("DOMContentLoaded", () => {
            let lastFocusedButton: HTMLElement | null = null;
            const triggers = document.querySelectorAll(triggerSelector);

            triggers.forEach((button: HTMLElement) => {
                button.addEventListener("click", (event: Event) => {
                    lastFocusedButton = event.currentTarget as HTMLElement;
                    const modal = document.querySelector(modalSelector) as HTMLElement | null;
                    if (!modal) return console.log("modal not existing");
                    modal.style.display = "block";
                    modal.setAttribute("tabindex", "-1");
                    modal.focus();
                });
            });

            const closeButton = document.querySelector(closeButtonSelector) as HTMLElement | null;
            closeButton?.addEventListener("click", () => {
                if (lastFocusedButton) {
                    lastFocusedButton.focus();
                }
            });
        });
    }
}